const playerStatusIconActive = {
  code: "check-e",
  color: "var(--nxgds-text-semantic-success-primary, #15a772)",
} as const;

const playerStatusIconInactive = {
  code: "void",
  color: "var(--nxgds-text-semantic-error-primary, #dd415c)",
} as const;

const playerStatusIconGameStatus = {
  code: "globe-a2",
  color: "var(--nxgds-text-semantic-info-primary, #0088ef)",
} as const;

export const playerStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: playerStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: playerStatusIconInactive,
  },
  {
    value: 3,
    title: "common.status.game_status",
    icon: playerStatusIconGameStatus,
  },
];

export const playerGamesStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: playerStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: playerStatusIconInactive,
  },
];

export const playerAssignmentStatusOptions = [
  { value: 1, title: "common.status.active" },
  { value: 2, title: "common.status.inactive" },
  { value: 3, title: "common.status.departed" },
];

export const PLAYER_MAX_POSITION = 999999;
